<template>
  <v-card>
    <v-card-title>{{ trans('survey.surveyFeedback') }}</v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col :cols="colsLeft">
          <survey-chart :data="totalChartData" />
        </v-col>
        <v-col :cols="colsRight">
          <survey-chart :data="relativeChartData" chart-type="pie" :colors="pieChartColors" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import SurveyChart from '@/components/survey/statistic/SurveyChart';
import colors from 'vuetify/lib/util/colors';
import {SurveyStatisticCardMixin} from '@/components/survey/statistic/SurveyStatisticCardMixin';

export default {
  name: 'SurveyStatisticsSummaryCard',
  components: {SurveyChart},
  mixins: [
    LocaleUtils,
    SurveyStatisticCardMixin
  ],
  props: {
    surveyStatisticsSummary: {
      required: true
    }
  },
  computed: {
    totalChartData () {
      return [
        [this.trans('survey.statistic.sentTotal'), this.surveyStatisticsSummary?.totalSent || 0],
        [this.trans('survey.statistic.openedTotal'), this.surveyStatisticsSummary?.totalOpened || 0],
        [this.trans('survey.statistic.answeredTotal'), this.surveyStatisticsSummary?.totalAnswered || 0],
      ];
    },
    relativeChartData () {
      return [
        [this.trans('survey.statistic.notYetOpened'), this.surveyStatisticsSummary?.statusSent || 0],
        [this.trans('survey.statusSurveyOpened'), this.surveyStatisticsSummary?.statusOpened || 0],
        [this.trans('survey.statusSurveyReplied'), this.surveyStatisticsSummary?.statusAnswered || 0],
      ];
    },
    pieChartColors () {
      return [
        '#eed29b',
        '#b2d05e',
        colors.green.base
      ]
    }
  }
}
</script>

<style scoped>

</style>
